import React, {Component} from 'react'
import {FaTrashAlt} from 'react-icons/fa'
import {connect} from 'react-redux'
import {NavLink} from 'react-router-dom'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import {asyncMethod} from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import {scrollToHtmlElementById} from '../../../../utilities/JSUtil'
import {getSessionItem} from '../../../../utilities/SessionHelper'
import Button from '../../../atoms/Button/Button'
import withFormLayout from '../WithFormLayout'
import './RoomTypeBuckets.scss'
import RoomTypeBucketsService from "../../../../services/RoomTypeBucketsService";
import RoomTypesService from "../../../../services/RoomTypesService";
import MultiCard from "../../../molecules/Card/MultiCard";
import {Col, Row} from "react-bootstrap";
import URLConst from "../../../../constants/URLConst";
import FormModal from "../../../organisms/FormModal/FormModal";
import {FORM_ROOM_TYPES_NAME, LABEL_ROOM_TYPE_BUCKETS} from "../../../../constants/FormConst";

class RoomTypeBuckets extends Component {

    constructor(props) {
        super(props)
        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const brandName = hotelInfo.brandName

        if (!hotelCode || !hotelInfo) {
            // Go home
            this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
        }

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            roomTypeBuckets: [],
            roomTypes: [],
            availableRoomTypes: [],
            continueFlow: this.props.history.location?.state?.continueFlow,
            isEdit: this.props.history.location?.state?.isEdit,
            editIndex: this.props.history.location?.state?.editIndex !== undefined ? this.props.history.location?.state?.editIndex : -1,
            initialValues: this.initialValues,
            showNewFields: this.props.history.location?.state?.showNewFields,
            errorMessage: undefined,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            showResetModal: false,
            showDeleteModal: false,
            showErrorModal: false
        }
    }

    // Default initial values for form fields
    initialValues = {
        name: '',
        level: 1,
        roomTypes: [],
        type: FormConst.ROOM_TYPE_BUCKET
    }



    /**
     * Lifecycle method that runs after the component mounts. Gets data from the service and sets
     * initial values for the form.
     */
    async componentDidMount() {
        await this.refreshData()
    }


    /**
     * Lifecycle method to handle this component's update. Only handles updates which are a result
     * of HTTP async actions.
     * 
     * @param {Object} prevProps properties before the current update
     */
    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    errorMessage: this.props.errorDescription
                })
            } else {
                if (!!this.state.resetFormData) {
                    this.state.resetFormData()
                }
                this.setState({
                    isLoading: false,
                    roomTypeBuckets: [...this.state.roomTypeBuckets],
                    isEdit: false,
                    editIndex: -1,
                    initialValues: { ...this.initialValues },
                    showNewFields: false,
                    showErrorModal: false
                })
            }
        }
    }

    async refreshData () {
        let existingRoomTypeBuckets = []
        let assignedRoomTypes = []
        let roomTypes = []
        let availableRoomTypes = []
        let initialValues = { ...this.initialValues }


        await RoomTypeBucketsService.getRoomTypesBuckets({ hotelCode: this.state.hotelCode }).then(async (response) => {
            existingRoomTypeBuckets = response.roomTypeBuckets
            existingRoomTypeBuckets.map(bucket => {
                bucket.roomTypes.map(roomType => { assignedRoomTypes.push(roomType)} )
            })
        }).catch(error => {
            this.setState({
                              isLoading: false,
                              showErrorModal: true,
                              errorMessage: 'There was an error while retrieving Hotel Room Type Buckets data'
                          })
        })

        // retrieve hotel room type buckets
        await RoomTypesService.getRoomTypes({hotelCode: this.state.hotelCode})
            .then(async (response) => {
                roomTypes = response.roomTypes
                availableRoomTypes = roomTypes.filter( roomType => !assignedRoomTypes.includes(roomType.hotelRoomTypeCode))

            }).catch(error => {
                this.setState({
                                  isLoading: false,
                                  showErrorModal: true,
                                  errorMessage: 'There was an error while retrieving Hotel Room Types data'
                              })
            })

        if (this.props.history.location.state && this.props.history.location.state.isEdit
            && this.props.history.location.state.editIndex !== undefined) {
            const entryToEdit = existingRoomTypeBuckets[this.props.history.location.state.editIndex]

            initialValues = {
                name: entryToEdit.name,
                level: entryToEdit.level,
                roomTypes: entryToEdit.roomTypes,
                type: FormConst.ROOM_TYPE_BUCKET
            }
        }

        this.setState({
                          isLoading: false,
                          roomTypeBuckets: existingRoomTypeBuckets,
                          availableRoomTypes: availableRoomTypes,
                          roomTypes: roomTypes,
                          isEdit: this.props.history.location?.state?.isEdit,
                          editIndex: this.props.history.location?.state?.editIndex !== undefined
                                     ? this.props.history.location?.state?.editIndex : -1,
                          initialValues: initialValues,
                          showNewFields: this.props.history.location?.state?.showNewFields,
                      })

    }

    /**
     * Handles transition out of the page
     */
    handleProceed = () => {
        this.props.history.push(RouteConst.ROUTE_ROOM_TYPE_BUCKETS_PAGE)
    }

    /**
     * This method handles the delete operation
     * @param name the name of the bucket to be deleted
     */
    async deleteBucket(e) {
        e.preventDefault()
        const data = {
            hotelCode: this.state.hotelCode,
            name: this.state.bucketName
        }
        await RoomTypeBucketsService.deleteRoomTypesBuckets(data)
        this.refreshData()
        this.setState( {showDeleteModal:false} )
    }

    /**
     * Displays the room type bucket details fields.
     */
    showNewRoomTypeBucketFields = () => {
        this.props.history.push(
            {
                pathname: RouteConst.ROUTE_ROOM_TYPE_BUCKET_PAGE,
                state: {
                    isEdit: false,
                    editIndex: -1,
                    initialValues: this.initialValues,
                    roomTypes: this.state.availableRoomTypes,
                    errorMessage: undefined
                }
            })
    }

    render() {
        let addRoomTypeBucketButton = this.state.roomTypeBuckets.length < FormConst.MAX_ROOM_TYPE_BUCKETS ?
                                      <Button
                                          name='Add Room Type Bucket'
                                          role="primary"
                                          type="button"
                                          id="room-type-buckets-add-button"
                                          className="room-type-buckets-add-button"
                                          overridedisabledflag='true'
                                          onClick={this.showNewRoomTypeBucketFields} />
                                      : "No more buckets can be configured"

        let cardsDataForRoomType = this.state.availableRoomTypes.map((roomType, index) => {
            return {
                // header: RoomTypes,
                title: roomType.hotelRoomTypeCode,
                text: (
                <dl>
                    {
                        roomType.masterRoomTypeCode && (
                            <>
                                <dt>Master Room Type</dt>
                                <dd>{roomType.masterRoomTypeCode}</dd>
                            </>
                        )
                    }
                    {
                        roomType.description && (
                            <>
                                <dt>Description</dt>
                                <dd>{roomType.description}</dd>
                            </>
                        )
                    }
                    {
                        roomType.maxOccupancy && (
                         <>
                             <dt>Max Occupancy</dt>
                             <dd>{roomType.maxOccupancy}</dd>
                         </>
                     )}
                    {
                        roomType.roomCount && (
                            <>
                                <dt>Count</dt>
                                <dd>{roomType.roomCount}</dd>
                            </>
                    )}
                </dl>
            ),
                actions: [],
                isSmall: true
            }
        })

        let cardsDataForRoomTypeBuckets = this.state.roomTypeBuckets.map((bucket, index) => {
            return {
                // header: Buckets,
                title: bucket.name,
                text: (
                    <dl>
                        {
                            bucket.level && (
                                <>
                                    <dt>Level</dt>
                                    <dd>{bucket.level}</dd>
                                </>
                            )
                        }
                        {
                            bucket.roomTypes && (
                                <table
                                    id='room-type-buckets-page-table'
                                    className='table table-striped table-responsive room-type-buckets-page-table'>
                                    <thead>
                                    <tr>
                                        <th className="w-25">Name</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        bucket.roomTypes?.length > 0 ?
                                        (
                                            bucket.roomTypes.map((roomType, index) => {
                                                return <tr key={index}>
                                                    <td>{roomType}</td>
                                                </tr>
                                            })
                                        )
                                                                     : (
                                            <tr>
                                                <td colSpan={7}>There are no entries for roomTypes</td>
                                            </tr>
                                        )
                                    }
                                    </tbody>
                                </table>

                            )

                        }
                    </dl>
                ),
                actions: [{
                    'onClick': () => this.props.history.push(
                        {
                            pathname: RouteConst.ROUTE_ROOM_TYPE_BUCKET_PAGE,
                            state: {
                                isEdit: true,
                                editIndex: index,
                                initialValues: this.initialValues,
                                roomTypes: this.state.availableRoomTypes,
                                errorMessage: undefined
                            }
                        }),
                    'label': 'Edit'
                }, {
                    'onClick': () => this.setState({ showDeleteModal: true, bucketName: bucket.name }),
                    'label': 'Delete'
                }],
                isSmall: true
            }
        })




        let roomTypeCards = this.state.roomTypes?.length > 0
                        ? <MultiCard
                            id='room-type-card'
                            header={FormConst.LABEL_ROOM_TYPES}
                            data={cardsDataForRoomType}
                            actions={[]}
                            footer={''}
                            isFill />
                        : <MultiCard
                            id='room-type-card'
                            header={FormConst.LABEL_ROOM_TYPE_BUCKET}
                            title={'No room type details. Click add to enter the details.'}
                            data={[]}
                            actions={[]}
                            footer={'There are no room types configured for this property.'}
                            isFill />

        let roomTypeBucketCards = this.state.roomTypeBuckets?.length > 0
                           ? <MultiCard
                               id='room-type-card'
                               header={FormConst.LABEL_ROOM_TYPE_BUCKETS}
                               data={cardsDataForRoomTypeBuckets}
                               actions={[]}
                               footer={addRoomTypeBucketButton}
                               isFill />
                           : <MultiCard
                               id='room-type-card-empty'
                               header={FormConst.LABEL_ROOM_TYPE_BUCKETS}
                               title={'No bucket details. Click add to enter the details.'}
                               data={[]}
                               actions={[]}
                               footer={addRoomTypeBucketButton}
                               isFill />

        return (
            <div className='room-type-buckets-page'>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_ROOM_TYPES_PAGE}>Room Types</NavLink></li>
                        <li className="breadcrumb-item active" aria-current="page">Room Type Buckets</li>
                    </ol>
                </nav>
                {
                    !this.state.isLoading
                    && (
                        <div className='room-type-buckets-cads'>

                            <Row className='justify-content-start card-room-type'>
                                <Col xl={12} className='d-flex box'>
                                    {roomTypeCards}
                                </Col>
                            </Row>

                            <Row className='justify-content-start card-room-type-buckets'>
                                <Col xl={12} className='d-flex box'>
                                    {roomTypeBucketCards}
                                </Col>
                            </Row>

                            <FormModal
                                id='hotel-contacts-page-delete-modal'
                                hotelInfo={this.state.hotelInfo}
                                title='Delete Room Type Bucket'
                                body={<h5>{FormConst.MODAL_DELETE_ACTION_TEXT}</h5>}
                                proceed={(e) => this.deleteBucket(e)}
                                cancel={() => { this.setState({ showDeleteModal: false}) }}
                                show={this.state.showDeleteModal} />
                        </div>
                    )
                }

            </div>

        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        roomTypeBucketsResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGetRoomTypeBuckets: (data) => dispatch(asyncMethod(FormConst.FORM_ROOM_TYPE_BUCKETS, actionTypes.ASYNC_ACTIONS.GET, data)),
        onGetRoomTypes: (data) => dispatch(asyncMethod(FormConst.FORM_ROOM_TYPES_NAME, actionTypes.ASYNC_ACTIONS.GET, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(RoomTypeBuckets, SideNavEntryMapping.ROOM_TYPES))